<template>
  <div id="loginPage" class="container">
    <div class="login-selector">
      <div class="frame frameleft">
        <div class="plateforme-client">
          <div class="text-wrapper" v-text="$t('form.login.clientMode')"/>
        </div>
      </div>
      <div class="frame frameRight">
        <div class="plateforme-candidat">
          <div class="text-wrapper"  @click="goToCandidateSiteButton">
            {{ $t("form.login.candidateMode") }}
          </div>      
        </div>
      </div>
    </div>
    <img
      class="logo"
      :src="`/images/logo-font-${isDark ? 'white' : 'black'}.svg`"
      alt="Logo yuzu"
    />
    <h2 v-text="$t('form.login.welcomeBack')" />
    <VForm
      :button="{
        label: $t('actions.signIn'),
        class: 'primary full-size',
        hotDisabled: false,
      }"
      :displayErrors="false"
      :displayErrorsOnSubmit="true"
      :callback="submit"
    >
      <template #form-body>
        <VField
          label="Adresse e-mail"
          type="email"
          placeholder="adresse@email.com"
          name="email"
          rules="required|email"
          v-model="state.mail"
          icon="bi-at"
          :required="true"
        />
        <VField
          type="password"
          label="Mot de passe"
          placeholder="••••••••••••"
          name="password"
          rules="required|password"
          v-model="state.password"
          icon="bi-lock"
          :required="true"
        />
      </template>
      <template #form-error="{ errors }">
        <div
          v-if="Object.keys(errors).length > 0 || state.error"
          class="form-error small"
          v-text="getError('ERROR_AUTH_INVALID_CREDENTIALS')"
        />
      </template>
    </VForm>
    <div class="addons column">
      <div class="input-inline">
        <div class="checkbox-group">
          <input
            type="checkbox"
            id="remember"
            name="remember"
            v-model="state.stayConnected"
          />
          <label for="remember" v-text="$t('form.login.rememberMe')" />
        </div>
        <router-link :to="{ name: 'forgotPassword' }" class="semibold">{{
          $t("form.login.forgotPassword")
        }}</router-link>
      </div>
      <div class="separator">
        <span v-text="$t('global.or')" />
      </div>
      <router-link
        class="btn secondary full-size"
        :to="{ name: 'registerPage' }"
        @click="goToRegisterButtonAction()"
      >
        {{ $t("actions.signUp") }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/stores/user.js";
import { useCompanyStore } from "@/stores/company.js";
import { useDark } from "@vueuse/core";
import { getError } from "@/composables/error.js";
import { event } from "vue-gtag";

const isDark = useDark();

const userStore = useUserStore();
const companyStore = useCompanyStore();
const { companies } = storeToRefs(companyStore);

const route = useRoute();
const router = useRouter();

const state = reactive({
  mail: "",
  password: "",
  isSubmit: false,
  stayConnected: false,
  error: null,
});

async function submit() {
  const loginAttempt = await userStore.login(state.mail, state.password);

  if (loginAttempt.error === "ERROR_NO_COMPANY") {
    router.push({ name: "registerPage" });
    return;
  }

  if (!loginAttempt.key && companies.value.length > 0) {
    state.error = null;
    const routeToPush = route.meta.from ?? {
      name: "home",
      params: { companyId: companies.value[0].company_id },
    };
    router.push(routeToPush);
  } else {
    state.error = loginAttempt.key;
  }
}

function goToRegisterButtonAction() {
  userStore.user = {};
  event("goto_register");
}

function goToCandidateSiteButton() {
  // Get the current URL
  let currentURL = window.location.href;

  // Replace app with 'game'
  let modifiedURL = currentURL.replace('app', 'game');

  // Redirect to the modified URL
  window.location.href = modifiedURL;
}

</script>

<style>
.login-selector {
  align-items: center;
  display: flex;
  position: relative;
  padding-bottom: 48px;
}

.login-selector .frame {
  align-items: flex-start;
  background-color: #f2cb36;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 10px;
  padding: 5px;
  position: relative;
}

.login-selector .frameleft {
  border-radius: 4px 0px 0px 4px;
}
.login-selector .frameRight{
  border-radius: 0px 4px 4px 0px;
}

.login-selector .text-wrapper {
  color: #1d1d1d;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  width: fit-content;
}

.login-selector .plateforme-client {
  align-items: center;
  text-align: center;
  align-self: stretch;
  background-color: #ffffff;
  border-radius: 4px;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: center;
  padding: 10px 24px;
  position: relative;
  width: 100%;
}

.login-selector .plateforme-candidat {
  align-items: center;
  text-align: center;
  background-color: #f2cb36;
  display: flex;
  flex: 1;
  flex-grow: 1;
  gap: 8px;
  justify-content: center;
  padding: 10px 24px;
  position: relative;  
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.login-selector .plateforme-candidat:hover {
  background-color: #F0C110;
}
</style>